<template>
  <div class="sap">
    <el-tooltip
      class="item"
      effect="light"
      content="返回工作台"
      placement="right"
    >
      <div class="sap-btn" @click="gotoPage">
        <img :src="sapIcon" />
        <!-- <el-button type="primary" plain @click="gotoPage" size="small">返回</el-button> -->
      </div>
    </el-tooltip>
    <div class="sap-content">
      <div class="sap-item-title">
        <img src="../../assets/xxzx.png" alt />
        <span>SAP账户解锁与密码修改</span>
      </div>
      <el-card class="box-card" shadow="always">
        <el-form
          class="sap-form"
          v-model="form.params"
          label-width="100px"
          label-position="left"
          size="medium"
        >
          <el-form-item label="SAP账号">
            <el-input
              placeholder="请输入sap账号"
              v-model="form.params.psnCode"
              clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item label="需求类型">
            <el-select v-model="form.params.needType" placeholder="请选择">
              <el-option label="账户解锁" value="unlock"></el-option>
              <el-option label="重置密码" value="pwd"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-if="form.params.needType == 'pwd'">
          <el-button
            type="primary"
            style="margin-left: 100px"
            @click="submitForm"
            >重置</el-button
          >
        </template>
        <!-- 以下账户解锁 -->
        <template v-if="form.params.needType == 'unlock'">
          <el-button type="primary" style="margin-left: 100px" @click="unLock"
            >解锁</el-button
          >
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
import * as Api from "../../api/sapwmsApi";
import sapIcon from "../../assets/sapIcon.jpg";
export default {
  data() {
    return {
      form: {
        params: {
          needType: "", //需求类型
          psnCode: "", //工号
        },
      },
      sapIcon: sapIcon,
    };
  },
  mounted() {},
  methods: {
    submitForm() {
      //密码修改
      let _this = this;
      let params = {
        type: _this.form.params.needType,
        account: _this.form.params.psnCode,
        password: "1234.com",
      };
      Api.unLockOrModifyPwd(params)
        .then((res) => {
          if (res.success) {
            this.$message({
              message: res.data,
              type: "success",
              offset: 120,
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
          this.$message.error("修改失败！");
        });
    },
    unLock() {
      //账户解锁
      let _this = this;
      let params = {
        type: _this.form.params.needType,
        account: _this.form.params.psnCode,
      };
      Api.unLockOrModifyPwd(params)
        .then((res) => {
          if (res.success) {
            this.$message({
              message: res.data,
              type: "success",
              offset: 120,
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
          this.$message.error("解锁失败！");
        });
    },
    gotoPage() {
      //返回按钮事件
      this.$router.push({
        path: "./workplace",
      });
    },
  },
};
</script>
<style scoped>
.sap-content {
  width: 710px;
  margin: auto;
  padding-top: 40px;
}
::v-deep .el-card {
  border: 1px solid #2196f3;
  background-color: #fff;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  padding: 30px 30px 40px 166px;
  border-radius: 32px;
}
::v-deep label.el-form-item__label {
  font-size: 17px;
}
.sap-item-title {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  justify-content: center;
}
.sap-item-title img {
  margin-right: 12px;
}
.sap-item-title span {
  color: #2196f3;
  font: 28px "Source Han Sans CN";
}
.sap-btn {
  padding: 22px 0px 0px 22px;
  cursor: pointer;
  width: 35px;
}
.sap-btn img {
    width: 100%;
    border-radius: 10px;
}
::v-deep input.el-input__inner {
  width: 222px;
}
</style>
